import TextField from '@material-ui/core/TextField'
import { FORM_LABELS, FORM_ERROR_TEXT } from '../constants'

const FormInput = ({
  fieldName,
  onChange,
  formRefs,
  formErrors,
  formData,
  shrink,
  required,
  disabled,
  uncontrolled,
  onFocus,
}) => {
  const getHtmlAutocomplete = (fieldName) => {
    switch (fieldName) {
      case 'last_name':
        return 'family-name'
      case 'first_name':
        return 'given-name'
      case 'postcode':
        return 'postal-code'
      case 'phone_number':
        return 'tel'
      case 'town':
        return 'address-level2'
      case 'address':
        return 'street-address'
      case 'amount':
        return 'transaction-amount'
      default:
        return fieldName
    }
  }

  const getType = (fieldName) => {
    switch (fieldName) {
      case 'phone_number':
        return 'tel'
      case 'donation':
        return 'number'
      case 'email':
        return 'email'
      default:
        return 'text'
    }
  }

  const extraProps = uncontrolled ? {} : { value: formData[fieldName] }

  return (
    <TextField
      InputProps={{
        disableUnderline: true,
        inputProps: fieldName === 'amount' ? { min: 1 } : {},
      }}
      variant="outlined"
      fullWidth
      inputRef={formRefs[fieldName]}
      placeholder={`${FORM_LABELS[fieldName]} ${required ? '*' : ''}`}
      error={formErrors[fieldName]}
      helperText={formErrors[fieldName] && FORM_ERROR_TEXT[fieldName]}
      onChange={(e) => onChange(fieldName, e)}
      required={required}
      name={fieldName}
      autoComplete={getHtmlAutocomplete(fieldName)}
      InputLabelProps={{ shrink }}
      disabled={disabled}
      type={getType(fieldName)}
      {...extraProps}
      onFocus={onFocus}
    />
  )
}

export default FormInput
